import {SettingParamTypes} from "@/types/node";

import {SettingInput} from "./SettingInput";
import {SettingSelect} from "./SettingSelect";
import {SettingTextarea} from "./SettingTextarea";
import {SettingPrompt} from "./SettingPrompt";
import {SettingModal} from "./SettingModal";
import {SettingNodeSelect} from "./SettingNodeSelect";
import {SettingCapture} from "./SettingCapture";
import {SettingEndpoint} from "./SettingEndpoint";
import {SettingMultiple} from "./SettingMultiple";
import {SettingSwitch} from "./SettingSwitch";
import {SettingTabs} from "./SettingTabs";
import {SettingAuthenticate} from "./SettingAuthenticate";
import {SettingJson} from "./SettingJson";
import {SettingVariableSelect} from "./SettingVariableSelect";
import {SettingDeterministicCondition} from "./SettingDeterministicCondition";

export {
  SettingInput,
  SettingSelect,
  SettingTextarea,
  SettingPrompt,
  SettingModal,
  SettingNodeSelect,
  SettingCapture,
  SettingEndpoint,
  SettingMultiple,
  SettingSwitch,
  SettingTabs,
  SettingAuthenticate,
  SettingJson,
  SettingVariableSelect,
  SettingDeterministicCondition,
};

export const SettingComponentMap = {
  [SettingParamTypes.SELECT]: SettingSelect,
  [SettingParamTypes.NODE_SELECT]: SettingNodeSelect,
  [SettingParamTypes.INPUT]: SettingInput,
  [SettingParamTypes.TEXTAREA]: SettingTextarea,
  [SettingParamTypes.PROMPT]: SettingPrompt,
  [SettingParamTypes.MODAL]: SettingModal,
  [SettingParamTypes.CAPTURE]: SettingCapture,
  [SettingParamTypes.ENDPOINT]: SettingEndpoint,
  [SettingParamTypes.MULTIPLE]: SettingMultiple,
  [SettingParamTypes.SWITCH]: SettingSwitch,
  [SettingParamTypes.TABS]: SettingTabs,
  [SettingParamTypes.AUTHENTICATE]: SettingAuthenticate,
  [SettingParamTypes.JSON]: SettingJson,
  [SettingParamTypes.VARIABLE_SELECT]: SettingVariableSelect,
  [SettingParamTypes.DETERMINISTIC_CONDITION]: SettingDeterministicCondition,
} as Record<SettingParamTypes, React.ComponentType<any>>;
